import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import { getVenueEnv } from '@/utils/helpers';
import { version, name } from '../../package.json';
import config from '../../config';

Bugsnag.start({
    appVersion: version,
    appType: name,
    apiKey: config.common.bugsnagApiKey,
    releaseStage: getVenueEnv(),
    plugins: [new BugsnagPluginVue()],
    enabledReleaseStages: ['development', 'staging', 'production'],
    autoTrackSessions: false,
});

Bugsnag.startSession();
